import React from "react";

const UserPrivateComponent = ({ children }) => {
	return <>{children}</>;
};

export default UserPrivateComponent;
